<div class="main-delete">
  <div class="text-part">
    <span class="text-part-title">{{ data.deleteTitle | translate }}</span>
    <span class="text-part-info">{{ data.deleteDescription | translate }}</span>
  </div>
  @if (!data.isSubscriptionPlanCancelPage) {
    <div class="action-part">
      <button class="option-cancel option-shared" [mat-dialog-close]="false">Cancel</button>
      <button class="option-delete option-shared" [mat-dialog-close]="true">Delete</button>
    </div>
  } @else {
    <div class="action-part">
      <button class="option-cancel option-shared" [mat-dialog-close]="true">{{"subscription_plan_content.yes" | translate}}</button>
      <button class="option-cancel-subscription option-shared" [mat-dialog-close]="false">{{"subscription_plan_content.no" | translate}}</button>
    </div>
  }
</div>
